import React from "react";
import { Box, Typography } from "@mui/material";
import { t } from "i18next";

export const DecemberWarning: React.FC<{ notInt: boolean }> = ({ notInt }) => {

    const isDecember = new Date().getMonth() === 11;
    if (!isDecember) return null;

    const isHalf = new Date().getDate() >= 15;
    let warningMessage = "";
    if (notInt) {
        if (isHalf) warningMessage = t("december.fakend")
        else warningMessage = t("december.fakstart")
    }else{
        warningMessage = t("december.intern")
    }

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>
            <Typography sx={{ color: 'warning.main', textAlign: 'center', width: '80%', fontSize: 18 }}>
                {warningMessage}
            </Typography>
        </Box>
    )
}